export class CancelPaymentInfo {
    StatementTransactionId: number;
    FundId: number;
    Note: string;
}
